module.exports = __webpack_public_path__ + "static/media/courses-header.a0f35f3c.jpg";